module.exports = __webpack_public_path__ + "static/media/detail_0025_t.e3381d67.jpg";